
  import JobAlertDialog from '@/components/JobAlertDialog';
  export default {
    components: {
      JobAlertDialog,
    },
    props: {
      organization: {
        type: Object,
        required: false,
        default: () => {},
      },
      title: {
        type: String,
        required: false,
        default: '',
      },
      subline: {
        type: String,
        required: false,
        default: '',
      },
      searchRequest: {
        type: String,
        required: false,
        default: '',
      },
      customTitle: {
        type: String,
        required: false,
        default: '',
      },
      typesenseStorageKey: {
        type: String,
        required: true,
        default: 'TypesenseParams',
      },
    },
    async created() {
      if (process.client) {
        const collection = this.organization ? 'organization' : 'job_posting';
        const typesenseParams = new URLSearchParams();
        typesenseParams.set('q', '*');
        typesenseParams.set('collection', collection);
        typesenseParams.set('per_page', 16);
        typesenseParams.set('page', 1);
        typesenseParams.set('max_facet_values', 100);
        typesenseParams.set('facet_by', 'activity,industry,employment_types');
        typesenseParams.set(
          'sort_by',
          `order_number(missing_values: last):desc`
        );
        const searches = [typesenseParams];
        const typesenseSearches = searches.map((search) =>
          Object.fromEntries(search)
        );

        await this.$localforage.setItem(
          this.typesenseStorageKey,
          typesenseSearches[0]
        );
      }
    },
  };
